import { useState } from 'react';
import { FaWheelchair } from 'react-icons/fa';
import { useTheme } from 'src/styles/theme';

import classes from './style/FloatingButton.module.css';

const FloatingButton = ({ actions }: any) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  // Set open state to true if user hover over "ul" element
  const mouseEnter = () => setOpen(true);

  // Set open state to false if user hover out of "ul" element
  const mouseLeave = () => setOpen(false);

  return (
    <ul
      className={classes['fab-container']}
      onMouseEnter={mouseEnter}
      onMouseLeave={mouseLeave}
      onKeyUp={mouseEnter}
      onKeyDown={mouseLeave}
      tabIndex={1}
    >
      <li className={classes['fab-button']}>
        <FaWheelchair />
      </li>
      {actions.map((action: any, index: number) => (
        <li
          style={{ transitionDelay: `${index * 25}ms` }}
          className={`${classes['fab-action']} ${open ? classes.open : ''}`}
          key={index}
          onClick={action.onClick}
          onKeyPress={action.onClick}
          tabIndex={index + 1}
        >
          {action.icon}
          <span
            className={`${classes['tooltip']} ${theme.fonts.classNames.inputLabel}`}
          >
            {action.label}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default FloatingButton;
